import React, {Component} from "react";
import cn from "classnames";

class OrderItem extends Component {
    constructor(props) {
        super(props);

    }
    cancel =  () => {
        this.props.cancelSalesOrder(this.props.salesOrder.id)
    }

    render () {
        const {salesOrder} = this.props

        return (
            <div className="list-group-item row">
                <h4>Заявка {salesOrder.id}
                </h4>

                <span className={cn('label', {
                    'label-success': salesOrder.isCompleted(),
                    'label-warning': salesOrder.isWaitingInProgress(),
                    'label-primary': salesOrder.isNew(),
                    'label-danger': salesOrder.isCancelled(),
                    'label-info': salesOrder.isInProgress(),
                })}>{salesOrder.getReadableStatus()}</span>

                <div className="col-xs-10 task-comment">
                    <ul className="list-group">
                        <li className="list-group-item">Цена: {salesOrder.price}</li>
                        <li className="list-group-item">Объем: {salesOrder.volume}</li>
                        <li className="list-group-item">Адрес: {salesOrder.address}</li>
                        <li className="list-group-item">Качество: {salesOrder.quality}</li>
                        <li className="list-group-item">Создано: {salesOrder.createdAt}</li>
                        <li className="list-group-item">Просрочится: {salesOrder.overdueAt}</li>
                    </ul>
                </div>
                <div className="col-xs-2">
                    <div className="task-comment-form col-xs-12 mr-top-20">
                        <div className="clearfix">
                            <button
                                onClick={this.cancel}
                                className="btn btn-danger pull-left"
                                disabled={!salesOrder.canBeCancelled()}
                            >Отменить</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderItem;


// WEBPACK FOOTER //
// ./components/SalesOrders/List/OrderItem.js